// Port of api/fuel/app/classes/controller/api/monty/export/csv.php
import Constants from 'offline/constants'
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Config from 'offline/model/config'
import Search from 'offline/model/search'
import User from 'offline/model/user'
import Group from 'offline/model/group'
import Buddies from 'offline/model/buddies'
import Package from 'offline/filter/core/package'

function ownerForSearch(search) {
	if (search.get_data_type() === F.OWNER_USER) return User.with_id(search.get_data_id())
	if (search.get_data_type() === F.OWNER_GROUP) return Group.with_id(search.get_data_id())
	if (search.get_data_type() === F.OWNER_BUDDIES) return Buddies.with_id(search.get_data_id())
	return null
}

function resultTypeForSearch(search, filter) {
	var resultType = F.RESULT_GAME

	if (search.get_type() === F.CACHE_COLLECTION) resultType = F.RESULT_COLLECTION
	if (search.get_type() === F.CACHE_LISTING) resultType = F.RESULT_GAME
	if (search.get_type() === F.CACHE_PLAYS) resultType = F.RESULT_PLAY
	if (search.get_type() === F.CACHE_RATINGS) resultType = F.RESULT_RATING

	if (filter.play && filter.play.group && search.get_type() === F.CACHE_PLAYS) {
		resultType = F.RESULT_GAME
	}

	if (search.get_data_type() !== F.OWNER_USER && search.get_type() === F.CACHE_RATINGS) {
		resultType = F.RESULT_GAME
	}

	if (search.get_data_type() !== F.OWNER_USER || (filter.status && filter.status.merge)) {
		resultType = F.RESULT_GAME
	}

	return resultType
}

function pseudoTypeForSearch(search) {
	if (search.get_type() === F.CACHE_COLLECTION) return F.PSEUDO_COLLECTION
	if (search.get_type() === F.CACHE_LISTING) return F.PSEUDO_GAME
	if (search.get_type() === F.CACHE_PLAYS) return F.PSEUDO_PLAY
	if (search.get_type() === F.CACHE_RATINGS) return F.PSEUDO_RATING
	return F.PSEUDO_GAME
}

function packageTypeForSearch(search) {
	var types = [F.PACKAGE_GAME]

	if (search.get_type() === F.CACHE_COLLECTION) types.push(F.PACKAGE_COLLECTION)
	if (search.get_type() === F.CACHE_PLAYS) types.push(F.PACKAGE_PLAY)
	if (search.get_type() === F.CACHE_RATINGS) types.push(F.PACKAGE_RATING)

	return types
}

function canViewInventoryLocation(search, sessionConfig, ownerConfig, sessionUserId, owner) {
	if (search.get_data_type() !== F.OWNER_USER || !ownerConfig) return false

	return !!(
		ownerConfig.collection &&
		ownerConfig.collection.inventory &&
		ownerConfig.collection.inventory.location &&
		ownerConfig.collection.inventory.location.public
	) || owner.get_id() === sessionUserId
}

function packageConfig(search, owner, filter, sessionUserId, ownerConfig, sessionConfig) {
	var userID = sessionUserId

	if (search.get_data_type() === F.OWNER_USER) {
		userID = owner.get_id()
	} else if (search.get_data_type() === F.OWNER_BUDDIES) {
		userID = owner.get_user_id()
	}

	return {
		owner: owner,
		userID: userID,
		sessionID: sessionUserId,
		ownerType: search.get_data_type(),
		filterType: F.TYPE_GAMES,
		resultType: resultTypeForSearch(search, filter),
		cacheType: search.get_type(),
		pseudoType: pseudoTypeForSearch(search),
		packageType: packageTypeForSearch(search),
		users: search.get_user_index(),
		settings: {
			session: sessionConfig || {},
			owner: ownerConfig || false
		},
		can: {
			'view.inventory.location': canViewInventoryLocation(search, sessionConfig, ownerConfig, sessionUserId, owner)
		}
	}
}

function columnsForSearch(search, filter) {
	var columns = []

	if (search.get_type() === F.CACHE_COLLECTION) {
		if (search.get_data_type() === F.OWNER_USER) columns.push('Collection ID')
		columns.push('Game ID', 'Name', 'Expansion')
		if (search.get_data_type() === F.OWNER_USER) columns.push('Version ID', 'Version', 'Status')
		if (search.get_data_type() !== F.OWNER_USER) columns.push('Owners')
		columns.push('Min Players', 'Max Players', 'Recommended Players', 'Best Players', 'Min Duration', 'Max Duration', 'Weight', 'Plays')
		if (search.get_data_type() === F.OWNER_USER) columns.push('Last Play', 'Rating')
		if (search.get_data_type() !== F.OWNER_USER) columns.push('Group Rating', 'Group Votes')
		columns.push('BGG Rating', 'Rank', 'Estimated Value')
		if (search.get_data_type() === F.OWNER_USER) columns.push('Inventory Location')
		return columns
	}

	if (search.get_type() === F.CACHE_LISTING) {
		columns.push('Game ID', 'Name', 'Expansion', 'Min Players', 'Max Players', 'Recommended Players', 'Best Players', 'Min Duration', 'Max Duration', 'Weight', 'Plays')
		if (search.get_data_type() === F.OWNER_USER) columns.push('Last Play', 'Rating')
		if (search.get_data_type() !== F.OWNER_USER) columns.push('Group Rating', 'Group Votes')
		columns.push('BGG Rating', 'Rank')
		return columns
	}

	if (search.get_type() === F.CACHE_RATINGS) {
		columns.push('Game ID', 'Name', 'Expansion', 'Plays')
		if (search.get_data_type() === F.OWNER_USER) columns.push('Last Play', 'Comment', 'Comment Date', 'Rating', 'Rating Date')
		if (search.get_data_type() !== F.OWNER_USER) columns.push('Group Rating', 'Group Votes')
		columns.push('BGG Rating', 'Rank')
		return columns
	}

	if (search.get_type() === F.CACHE_PLAYS && !(filter.play && filter.play.group)) {
		return ['Play ID', 'Game ID', 'Name', 'Expansion', 'Date', 'Plays', 'Location', 'Duration', 'Incomplete', 'Report', 'Count', 'Players', 'Winner']
	}

	if (search.get_type() === F.CACHE_PLAYS && filter.play && filter.play.group) {
		columns.push('Game ID', 'Name', 'Expansion', 'Plays', 'Hours')
		if (search.get_data_type() === F.OWNER_USER) columns.push('Win %', 'Last play')
		if (search.get_data_type() !== F.OWNER_USER) columns.push('Users')
		return columns
	}

	return columns
}

function formatDate(value) {
	if (!value) return '-'
	return new Date(value * 1000).toISOString().slice(0, 10)
}

function listPlayers(value) {
	return Array.isArray(value) && value.length ? value.join(',') : '-'
}

function cleanText(value) {
	if (!value) return '-'
	return String(value)
		.replace(/<[^>]*>/g, ' ')
		.replace(/\s+/g, ' ')
		.trim() || '-'
}

function worthValue(item, ownerConfig) {
	var exchange = ownerConfig && ownerConfig.other && ownerConfig.other.currency && String(ownerConfig.other.currency).toUpperCase() !== 'USD'
		? Number(ownerConfig.other.exchange || 1)
		: 1

	return Math.round((Number(item.game.worth ? item.game.worth.value : 0) * exchange) * 100) / 100
}

function collectionRow(search, item, ownerConfig) {
	var row = []
	var status = []
	var key
	var plays = search.get_data_type() === F.OWNER_USER ? item.user.plays : item.users.totalPlays

	if (item.context) {
		plays = search.get_data_type() === F.OWNER_USER ? item.context.user.plays : item.context.users.totalPlays
	}

	if (search.get_data_type() === F.OWNER_USER) {
		for (key in item.user.status) {
			if (item.user.status[key]) status.push(key.charAt(0).toUpperCase() + key.slice(1))
		}
		row.push(item.id)
	}

	row.push(
		item.game.id,
		item.game.name,
		item.game.type === 2 ? 'Y' : '-'
	)

	if (search.get_data_type() === F.OWNER_USER) {
		row.push(
			item.game.version ? item.game.version.id : '-',
			item.game.version ? item.game.version.name : '-',
			status.join(',')
		)
	}

	if (search.get_data_type() !== F.OWNER_USER) row.push(Object.keys(item.users.status.own || {}).length)

	row.push(
		item.game.players_min,
		item.game.players_max,
		listPlayers(item.game.players_community ? item.game.players_community.recommended : []),
		listPlayers(item.game.players_community ? item.game.players_community.best : []),
		item.game.time_min,
		item.game.time_max,
		item.game.weight_avg,
		plays
	)

	if (search.get_data_type() === F.OWNER_USER) row.push(formatDate(item.user.play_last), item.user.rating_avg)
	if (search.get_data_type() !== F.OWNER_USER) row.push(item.group.rating_avg, item.group.rating_count)

	row.push(item.game.rating_avg, item.game.rank, worthValue(item, ownerConfig))

	if (search.get_data_type() === F.OWNER_USER) row.push(item.collection && item.collection.location !== false ? item.collection.location || '' : false)

	return row
}

function listingRow(search, item) {
	var plays = search.get_data_type() === F.OWNER_USER ? item.user.plays : item.users.totalPlays

	if (item.context) {
		plays = search.get_data_type() === F.OWNER_USER ? item.context.user.plays : item.context.users.totalPlays
	}

	var row = [
		item.game.id,
		item.game.name,
		item.game.type === 2 ? 'Y' : '-',
		item.game.players_min,
		item.game.players_max,
		listPlayers(item.game.players_community ? item.game.players_community.recommended : []),
		listPlayers(item.game.players_community ? item.game.players_community.best : []),
		item.game.time_min,
		item.game.time_max,
		item.game.weight_avg,
		plays
	]

	if (search.get_data_type() === F.OWNER_USER) row.push(formatDate(item.user.play_last), item.user.rating_avg)
	if (search.get_data_type() !== F.OWNER_USER) row.push(item.group.rating_avg, item.group.rating_count)

	row.push(item.game.rating_avg, item.game.rank)

	return row
}

function ratingRow(search, item) {
	var plays = search.get_data_type() === F.OWNER_USER ? item.user.plays : item.users.totalPlays

	if (item.context) {
		plays = search.get_data_type() === F.OWNER_USER ? item.context.user.plays : item.context.users.totalPlays
	}

	var row = [
		item.game.id,
		item.game.name,
		item.game.type === 2 ? 'Y' : '-',
		plays
	]

	if (search.get_data_type() === F.OWNER_USER) {
		row.push(
			formatDate(item.user.play_last),
			cleanText(item.comment ? item.comment.text : ''),
			formatDate(item.comment ? item.comment.date : 0),
			item.rating ? item.rating.rating : 0,
			formatDate(item.rating ? item.rating.date : 0)
		)
	}

	if (search.get_data_type() !== F.OWNER_USER) row.push(item.group.rating_avg, item.group.rating_count)

	row.push(item.game.rating_avg, item.game.rank)

	return row
}

function playRow(item) {
	var players = []
	var winners = []
	var i

	for (i = 0; i < (item.players || []).length; i++) {
		var player = item.players[i]
		players.push(player.name + (player.score ? ' (' + player.score + ')' : ''))
		if (player.win) winners.push(player.name)
	}

	return [
		item.play.play_id || item.play.id || item.id,
		item.game.id,
		item.game.name,
		item.game.type === 2 ? 'Y' : '-',
		formatDate(item.play.play_date || item.play.date),
		'x' + Number(item.play.play_count || item.play.count || 0),
		item.play.play_location || item.play.location || '-',
		item.play.play_length || item.play.length || '-',
		(item.play.play_incomplete || item.play.incomplete) ? 'Y' : '-',
		cleanText(item.play.play_comment || item.play.comment || ''),
		(item.players || []).length || '-',
		players.length ? players.join(', ') : '-',
		winners.length ? winners.join(', ') : '-'
	]
}

function playGameRow(search, item) {
	var plays = search.get_data_type() === F.OWNER_USER ? item.user.plays : item.users.totalPlays
	var hours = search.get_data_type() === F.OWNER_USER ? item.user.duration : item.users.totalDuration

	if (item.context) {
		plays = search.get_data_type() === F.OWNER_USER ? item.context.user.plays : item.context.users.totalPlays
		hours = search.get_data_type() === F.OWNER_USER ? item.context.user.duration : item.context.users.totalDuration
	}

	var row = [
		item.game.id,
		item.game.name,
		item.game.type === 2 ? 'Y' : '-',
		plays,
		Math.ceil(Number(hours || 0) / 60)
	]

	if (search.get_data_type() === F.OWNER_USER) {
		row.push(item.record && item.record.results ? Math.round((100 / item.record.results) * item.record.wins) + '%' : '-')
		row.push(formatDate(item.user.play_last))
	}

	if (search.get_data_type() !== F.OWNER_USER) row.push(Object.keys(item.users.played || {}).length)

	return row
}

function rowsForPackage(search, filter, pkg, nested, ownerConfig) {
	var rows = []
	var i
	var j

	for (i = 0; i < pkg.length; i++) {
		var item = pkg[i]

		if (search.get_type() === F.CACHE_COLLECTION) {
			rows.push(collectionRow(search, item, ownerConfig))
			for (j = 0; j < (item.nested || []).length; j++) {
				if (nested[item.nested[j]]) rows.push(collectionRow(search, nested[item.nested[j]], ownerConfig))
			}
			continue
		}

		if (search.get_type() === F.CACHE_LISTING) rows.push(listingRow(search, item))
		if (search.get_type() === F.CACHE_RATINGS) rows.push(ratingRow(search, item))
		if (search.get_type() === F.CACHE_PLAYS && !(filter.play && filter.play.group)) rows.push(playRow(item))
		if (search.get_type() === F.CACHE_PLAYS && filter.play && filter.play.group) rows.push(playGameRow(search, item))
	}

	return rows
}

function csvValue(value) {
	var text = value === false ? '' : String(value === undefined || value === null ? '' : value)
	return '"' + text.replace(/"/g, '""') + '"'
}

function csvContent(columns, rows) {
	var lines = [columns.map(csvValue).join(',')]
	var i

	for (i = 0; i < rows.length; i++) {
		lines.push(rows[i].map(csvValue).join(','))
	}

	return '\uFEFF' + lines.join('\r\n')
}

export default function(params) {
	var search = params.key ? Search.record({ where: [['search_key', '=', params.key]] }) : null
	var filter
	var index
	var owner
	var sessionUserId
	var sessionConfig
	var ownerConfig
	var config
	var packaged
	var rows
	var columns
	var csv

	if (!search) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	filter = search.get_filter() || {}
	index = params.index && params.index.length ? params.index : search.get_result_index()
	owner = ownerForSearch(search)
	sessionUserId = params.sessionUserId || Number(DB.meta('sync_user_id') || 0) || null

	if (!owner) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	sessionConfig = Config.user(sessionUserId)
	ownerConfig = search.get_data_type() === F.OWNER_USER ? Config.user(owner.get_id()) : false
	config = packageConfig(search, owner, filter, sessionUserId, ownerConfig, sessionConfig)
	packaged = Package.run(config, filter, {
		users: search.get_user_index(),
		nested: search.get_nested_index(),
		results: index,
		context: {}
	})

	columns = columnsForSearch(search, filter)
	rows = rowsForPackage(search, filter, packaged[0], packaged[1].nested || {}, ownerConfig)
	csv = csvContent(columns, rows)

	return Promise.resolve({
		session: { offline: true },
		data: {
			download: 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
		}
	})
}
